import { AnyAction, Store } from 'redux'

import { selectors as vehicleSelectors } from '@cinch/oxd-redux/vehicles/src'
import { customEventNames, updateVehicleInformation } from '@cinch/oxd-utils/analytics/src'

type actionType = 'add' | 'remove'

const favouriteEvent = (type: actionType) => (
  store: Store,
  action: AnyAction,
): Cinch.AnalyticsEvent<Cinch.DirectVehicleAdvertSummary> => {
  const state = store.getState()
  const { vehicleId } = action.payload

  const summary: Cinch.DirectVehicleAdvertSummary =
    vehicleSelectors.getListingById(state)(vehicleId) || vehicleSelectors.getSummaryById(state)(vehicleId)
  const vehicleInformation = { ...summary, vehicleProject: 'cambridge' }

  updateVehicleInformation(vehicleInformation)

  const eventNameMap = {
    add: customEventNames.addToFavourite,
    remove: customEventNames.removeFromFavourites,
  }

  return {
    name: eventNameMap[type],
    details: vehicleInformation,
  }
}

export default favouriteEvent
